import * as d3 from 'd3';
import { ElementRender } from './ElementeRenderer';
import { ItemFormat } from '../interfaces';
import { highlightOnHover } from './stroke-hover';

export class Bars extends ElementRender {
    private _listeners: { [event: string]: (d: ItemFormat, selection: d3.Selection<ItemFormat>) => void };

    constructor(selection: d3.Selection<any>) {
        super(selection, 'bars');
        this._listeners = {};
    }

    addListener(eventName: string, callback: (d: ItemFormat, selection: d3.Selection<ItemFormat>) => void) {
        this._listeners[eventName] = callback;
        return this;
    }

    removeListener(eventName: string) {
        delete (this._listeners[eventName]);
        return this;
    }

    render(data: ItemFormat[]) {
        this.container()
            .classed('hidden-group', !this.visible());
        const databound = this.container()
            .selectAll('rect')
            .data(data);
        databound.on('click', null)
            .exit()
            .remove();
        const enterSelection = databound.enter()
            .append('rect');
        highlightOnHover(enterSelection, this._listeners);
        enterSelection.append('title');
        databound
            .transition()
            .attr('x', d => d.x)
            .attr('y', d => Math.min(d.y, this.height()))
            .attr('width', d => d.width)
            .attr('height', d => d.height)
            .style('fill', d => d.item.classes.length ? null : d.color)
            .attr('class', d => d.item.classes.join(' '))
            .attr('transform', d => d.translate ? `translate(${d.translate.x}, ${d.translate.y})` : null);
        databound.on('click', (d, i) => {
            if (d.onClick) {
                d.onClick.bind(d);
                d.onClick();
            }
        });

        databound.select('title')
            .classed('hidden', d => !d.tooltip)
            .text(d => d.tooltip);
    }
}